export default __webpack_public_path__ + "static/media/PDV.c4bfe213.svg";